<template>
    <div id="main">
        <loader v-if="hideByRemove" />
        <div class="page" v-else>
            <div class="vertical-flow">
                <div class="listing-header">
                    <div class="title-breadcrumb">
                        <h1 class="title">
                            {{ $t("agro-visita") }}
                            <a
                                class="pl-1"
                                v-if="hide.hideInfo"
                                @click="infoIsHidden()"
                            >
                                <b-icon
                                    v-if="!hide.infoIsHidden"
                                    icon="eye-off-outline"
                                    type="is-danger"
                                />
                                <b-icon
                                    v-if="hide.infoIsHidden"
                                    icon="eye-outline"
                                    type="is-success"
                                />
                            </a>
                        </h1>
                        <nav class="breadcrumb" aria-label="breadcrumbs">
                            <ul>
                                <li>
                                    <a class="a-inativo">{{
                                        $t("agro")
                                    }}</a>
                                </li>
                                <li>
                                    <a
                                        @click="
                                            $router.push({
                                                name: 'agro-visita-list',
                                            })
                                        "
                                    >
                                        {{ $t("agro-visita") }}
                                    </a>
                                </li>
                                <li>
                                    <a aria-current="page">
                                        {{
                                            $route.params.id
                                                ? iderp
                                                : $t("novo")
                                        }}
                                    </a>
                                </li>
                            </ul>
                        </nav>
                    </div>
                    <div class="header-buttons">
                        <!-- BOTÕES DA EXPORTAÇÃO -->
                        <div
                            v-if="exportacaoTipo && permissao.export"
                            class="column is-3"
                        >
                            <div
                                class="exportIcons"
                                style="justify-content: flex-end"
                            >
                                <div
                                    v-if="exportacaoTipo.exportaemail == 1"
                                    class="export-icon"
                                    @click="checkExport('email')"
                                >
                                    <b-icon
                                        icon="email-outline"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-email')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportawhatsapp == 1"
                                    class="export-icon"
                                    @click="checkExport('whatsapp')"
                                >
                                    <b-icon
                                        icon="whatsapp"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-whatsapp')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportapdf == 1"
                                    class="export-icon"
                                    @click="checkExport('pdf')"
                                >
                                    <b-icon
                                        icon="file-pdf"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-pdf')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportaexcel == 1"
                                    class="export-icon"
                                    @click="checkExport('excel')"
                                >
                                    <b-icon
                                        icon="file-excel"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-excel')"
                                    />
                                </div>
                                <div
                                    v-if="exportacaoTipo.exportacsv == 1"
                                    class="export-icon"
                                    @click="checkExport('csv')"
                                >
                                    <b-icon
                                        icon="file"
                                        size="is-medium"
                                        class="is-medium is-clickable"
                                        v-tippy 
                                        :title="$t('msg-tooltip-csv')"
                                    />
                                </div>
                            </div>
                        </div>

                        <button
                            class="delete-btn"
                            type="button"
                            tag="button"
                            @click="redirectToList()"
                        >
                            {{ $t("voltar") }}
                        </button>
                        <button
                            v-if="isUpdate && situacao == 4 && permissao.create"
                            class="save-btn novo-registro"
                            type="button"
                            tag="button"
                            @click="
                                $router.push({
                                    name: 'agro-visita-item-new',
                                    params: { idvisita: $route.params.id },
                                })
                            "
                        >
                            {{ $t("novo-registro") }}
                        </button>
                        <button
                            v-if="
                                isUpdate &&
                                tiposOcorrencias.length > 0 &&
                                situacao == 4 &&
                                permissao.create
                            "
                            class="save-btn"
                            type="button"
                            tag="button"
                            @click="updateSituacao = true"
                        >
                            {{ $t("finalizar") }}
                        </button>
                        <button
                            v-if="isUpdate && situacao == 4 && permissao.delete"
                            class="save-btn excluir-visita"
                            type="button"
                            tag="button"
                            @click="deleteVisita = true"
                        >
                            {{ $t("excluir") }}
                        </button>
                    </div>
                </div>

                <ul
                    class="nav nav-tabs nav-tabs-children"
                    v-if="isUpdate"
                    key="agro-visita-manage"
                >
                    <li
                        v-for="(aba, i) in abas"
                        :key="i"
                        v-show="permissao.read"
                        :class="{ active: abaSelecionada == i }"
                        @click="changeTab(i)"
                    >
                        <a data-toggle="tab">
                            <span
                                v-if="aba.icone"
                                class="icon is-small"
                                :style="{ color: aba.cor }"
                            >
                                <i :class="aba.icone.toLowerCase()" />
                            </span>
                            {{
                                aba.id == 0
                                    ? $t(aba.descricao)
                                    : aba.descricao
                            }}
                        </a>
                    </li>
                </ul>

                <!-- CONJUNTO DE ABAS - MOBILE -->
                <b-dropdown
                    aria-role="list"
                    class="mobile-tab-list"
                    key="agro-visita-manage-mobile"
                >
                    <div slot="trigger" class="mobile-tab">
                        <span class="mobile-tab-text">
                            <span
                                v-if="abas[abaSelecionada].icone"
                                class="icon is-small"
                                :style="{ color: abas[abaSelecionada].cor }"
                            >
                                <i
                                    :class="
                                        abas[abaSelecionada].icone.toLowerCase()
                                    "
                                />
                            </span>
                            {{
                                abas[abaSelecionada].id == 0
                                    ? $t(abas[abaSelecionada].descricao)
                                    : abas[abaSelecionada].descricao
                            }}
                        </span>
                        <em class="mdi mdi-chevron-down"></em>
                    </div>

                    <b-dropdown-item
                        class="mobile-tab-list-item"
                        :class="{ active: abaSelecionada == i }"
                        aria-role="listitem"
                        v-for="(aba, i) in abas"
                        v-show="permissao.read"
                        :key="i"
                        @click="changeTab(i)"
                    >
                        <span
                            v-if="aba.icone"
                            class="icon is-small"
                            :style="{ color: aba.cor }"
                        >
                            <i :class="aba.icone.toLowerCase()" />
                        </span>
                        {{
                            aba.id == 0 ? $t(aba.descricao) : aba.descricao
                        }}
                    </b-dropdown-item>
                </b-dropdown>
                <div class="aba-visitaitem">
                    <Geral
                        ref="tabGeral"
                        v-if="abasAbertas[0] && !newToEdit && permissao.read"
                        v-show="abas[abaSelecionada].id == 0"
                        :isUpdate="isUpdate"
                        :cantEdit="cantEdit"
                        @isChanged="isChanged = $event"
                        @redirectList="redirectToList"
                        :updateSituacao="updateSituacao"
                        @updateSituacao="updateSituacao = $event"
                        :deleteVisita="deleteVisita"
                        @deleteVisita="deleteVisita = $event"
                        @situacao="situacao = $event"
                        @iderp="iderp = $event"
                    />
                    <span
                        v-for="(tipoOcorrencia, i) in tiposOcorrencias"
                        :key="i"
                        class="aba-visitaitem"
                    >
                        <keep-alive>
                            <VisitaItem
                                :ref="`tab-${tipoOcorrencia.id}`"
                                v-if="
                                    abasAbertas[tipoOcorrencia.id] &&
                                    permissao.read &&
                                    isUpdate
                                "
                                v-show="
                                    abas[abaSelecionada].id == tipoOcorrencia.id
                                "
                                :isUpdate="isUpdate"
                                :tipoOcorrencia="tipoOcorrencia"
                                :situacao="situacao"
                                @removeAba="removeAba"
                            />
                        </keep-alive>
                    </span>
                </div>
            </div>
        </div>
        <b-modal
            class="export-opcoes"
            :active.sync="isShowingTitle"
            style="z-index: 1000"
            @close="isShowingTitle = false"
        >
            <div
                class="modal-card modal-default center"
                style="max-width: 580px"
            >
                <section class="modal-card-body">
                    <div class="listing-header">
                        <div class="title-breadcrumb center">
                            <h1 class="title">
                                {{ $t("exportacao-dados") }}
                            </h1>
                        </div>
                    </div>
                    <div class="columns p-4">
                        {{ $t("title-exp") }}
                    </div>
                    <div class="columns is-full mx-1">
                        <div class="titulo-input">
                            <v-input
                                v-model="tituloExportacao"
                                :maxlength="100"
                                :title="'titulo-exp'"
                                :msg="'msg-campo-obrigatorio'"
                            />
                        </div>
                    </div>
                    <div class="columns ok">
                        <div class="form-buttons2">
                            <button
                                class="delete-btn"
                                type="button"
                                @click="isShowingTitle = false"
                            >
                                {{ $t("cancelar") }}
                            </button>
                            <button
                                class="save-btn"
                                type="button"
                                @click="saveExportacao()"
                            >
                                {{ $t("exportar-rel") }}
                            </button>
                        </div>
                    </div>
                </section>
            </div>
        </b-modal>
    </div>
</template>

<script>
import HideInfo from "@/components/shared/HideInfo";
import { mapState } from "vuex";
import TipoOcorrenciaService from "@/services/agro/ocorrencia/TipoOcorrenciaService";
import ExportacaoTipoService from "@/services/ExportacaoTipoService";
import ExportacaoService from "@/services/ExportacaoService";
import ExportacaoLogService from "@/services/ExportacaoLogService";
import ExportacaoDadosService from "@/services/ExportacaoDadosService";

// Abas
import Geral from "@/components/agro/agro-visita/abas/Geral.vue";
import VisitaItem from "@/components/agro/agro-visita/abas/VisitaItem.vue";

export default {
    beforeRouteLeave(to, from, next) {
        if (from.name == "agro-visita-new" && to.name == "agro-visita-edit") {
            this.isUpdate = true;

            this.newToEdit = true;
            setTimeout(() => {
                this.newToEdit = false;
            }, 500);
        }
        if (this.isChanged) {
            this.promptChangeTab(next);
        } else {
            next();
        }
    },
    components: {
        HideInfo,
        Geral,
        VisitaItem,
    },
    data() {
        return {
            tipoOcorrenciaService: new TipoOcorrenciaService(
                this.$http,
                this.$router
            ),
            exportacaoTipoService: new ExportacaoTipoService(
                this.$http,
                this.$router
            ),
            exportacaoService: new ExportacaoService(this.$http, this.$router),
            exportacaoLogService: new ExportacaoLogService(
                this.$http,
                this.$router
            ),
            exportacaoDadosService: new ExportacaoDadosService(
                this.$http,
                this.$router
            ),
            abaSelecionada: 0,
            abas: [
                {
                    id: 0,
                    descricao: "dados-cadastrais",
                },
            ],
            abasAbertas: {},
            tiposOcorrencias: [],
            isUpdate: false,
            isChanged: false,
            newToEdit: false,
            permissao: false,
            cantEdit: false,
            situacao: null,
            updateSituacao: false,
            deleteVisita: false,
            hideByRemove: false,
            iderp: null,

            exportacaoTipo: {},
            exportWithPhoto: false,
            isShowingTitle: false,
            tituloExportacao: null,
        };
    },
    mounted() {
        if (this.$route.query.abaSelecionada) {
            this.changeTab(this.abas.indexOf(this.$route.query.abaSelecionada));
        }
    },
    computed: {
        ...mapState(["hide"]),
    },
    watch: {
        situacao(val) {
            if (val != 4) this.cantEdit = true;
        },
    },
    created() {
        if (this.$route.params.id) this.isUpdate = true;

        this.permissao = this.hasPermissionAccess(
            "agro",
            "agro-visita",
            "agro-visita"
        );

        if (
            (!this.isUpdate && !this.permissao.create) ||
            (this.isUpdate && !this.permissao.read)
        ) {
            this.$router.push({
                name: "acesso-nao-permitido",
                params: { tela: "agro-visita" },
            });
        } else {
            this.cantEdit =
                (!this.$route.params.id && !this.permissao.create) ||
                (this.$route.params.id && !this.permissao.update);

            this.abasAbertas[0] = true;
            if (this.isUpdate) {
                this.carregaExportacaoTipo();
                this.carregarTiposOcorrencias();
            }
        }
    },
    methods: {
        infoIsHidden() {
            this.$store.dispatch("infoIsHidden", {
                infoIsHidden: !this.hide.infoIsHidden,
            });
        },
        changeTab(i) {
            this.abaSelecionada = i;
            this.abasAbertas[this.abas[this.abaSelecionada].id] = true;
        },
        promptChangeTab(next) {
            this.$root.confirm({
                message: this.$t("msg-tem-certeza-alteracoes"),
                onConfirm: (_) => {
                    this.isChanged = false;
                    next();
                },
                onCancel: (_) => {
                    next(false);
                },
            });
        },
        carregarTiposOcorrencias() {
            this.isLoading = true;
            this.tipoOcorrenciaService
                .findByAgroVisita(this.$route.params.id)
                .then((value) => {
                    this.tiposOcorrencias = Object.assign(value.content);
                    this.tiposOcorrencias.forEach((tipoOcorrencia) => {
                        this.abas.push(tipoOcorrencia);
                    });
                })
                .catch((e) => {
                    console.error(e);
                    this.msgs.push(new Message("error", "msg-erro-load", true));
                })
                .finally((_) => {
                    this.isLoading = false;
                    if (this.tiposOcorrencias.length > 0) this.cantEdit = true;
                    this.hideByRemove = false;
                });
        },
        redirectToList() {
            if (this.$route.query.tela) {
                let tempTela = null;
                let tempAba = null;
                let tempId = null;
                // if (this.$route.query.tela == "agro-cultura-edit") {
                //   tempAba = "ocorrencia";
                //   tempTela = this.$route.query.tela;
                //   tempId = this.$route.query["id"];
                // }
                if (tempTela != null) {
                    setTimeout(() => {
                        this.$router.push({
                            name: tempTela,
                            params: { id: tempId },
                            query: { abaSelecionada: tempAba },
                        });
                    }, 1000);
                } else {
                    this.$router.push({ name: "agro-visita-list" });
                }
            } else {
                this.$router.push({ name: "agro-visita-list" });
            }
        },
        removeAba() {
            this.hideByRemove = true;
            this.abaSelecionada = 0;
            this.abas = [{ id: 0, descricao: "dados-cadastrais" }];
            this.abasAbertas = {};
            this.abasAbertas[0] = true;
            this.tiposOcorrencias = [];
            this.cantEdit = false;
            this.carregarTiposOcorrencias();
        },
        carregaExportacaoTipo() {
            // Inidica qual a tela que será passada (ENUM ExportacaoTelas) para realizar a busca
            this.exportacaoTipoService.findByTela("AGROVISITA").then((body) => {
                if (body.content) {
                    this.exportacaoTipo = body.content;
                }
            });
        },
        checkExport(tipo) {
            this.exportWithPhoto = false;
            this.tipoExportacao = tipo;

            if (tipo == "pdf") {
                this.promptExportPdf();
            } else {
                this.isShowingTitle = true;
            }
        },
        // pedir se quer fotos se for pda
        promptExportPdf() {
            this.$root.confirm({
                message: this.$t("gerar-com-fotos"),
                onConfirm: () => {
                    this.exportWithPhoto = true;
                    this.isShowingTitle = true;
                },
                onCancel: () => {
                    this.exportWithPhoto = false;
                    this.isShowingTitle = true;
                },
            });
        },
        saveExportacao() {
            if (this.isNull(this.tituloExportacao)) {
                this.$root.showMessage("alert", "msg-valida-titulo");
            } else {
                this.isSaving = true;
                this.isShowingTitle = false;

                let exportacao = {
                    idexportacao: null,
                    titulo: this.tituloExportacao,
                    processoexportado: this.tipoExportacao,
                    situacao: "EXPORTANDO",
                    usuario: {
                        idusuarioerp: this.$store.state.user.idusuarioerp,
                    },
                    exportacaotipo: {
                        idexportacaotipo: this.exportacaoTipo.idexportacaotipo, //IDEXPORTACAOTIPO (REFERE-SE A QUAL TELA ESTA CHAMANDO A EXPORTACAO)
                    },
                };

                // salva o inicio da gração em fvw_exportacao
                this.exportacaoService
                    .save(exportacao)
                    .then((response) => {
                        this.$root.showMessage("success", "msg-exp-solicitada");
                        this.saveLog(response.content, this.tipoExportacao);

                        this.gerarArquivoExportacao(response.content);
                    })
                    .catch((e) => {
                        console.error("Erro ao salvar exportação.", e);
                        this.$root.showMessage("error", "msg-erro-exp-gerar");
                    })
                    .finally(() => {
                        this.isSaving = false;
                    });
            }
        },
        // Salva os dados na tabela fvw_exportacaolog
        saveLog(exportacao, tipo) {
            let exportacaoLog = {
                ///Objeto criado que será enviado ao banco
                destino: null,
                acao: "Solicitação da exportação listagem " + tipo,
                exportacao: exportacao,
                usuario: {
                    idusuarioerp: exportacao.usuario.idusuarioerp,
                },
            };
            this.exportacaoLogService
                .save(exportacaoLog)
                .then((r) => {})
                .catch((e) => {
                    console.error("Erro ao salvar log exportação.", e);
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                });
        },
        gerarArquivoExportacao(exportacao) {
            let exportacaoAgroVisita = {
                exportacao: exportacao,
                filtro: null,
                exportafoto: this.exportWithPhoto,
                usuario: this.$store.state.user,
            };

            this.exportacaoDadosService
                .saveAgroVisita(
                    exportacaoAgroVisita,
                    this.tipoExportacao,
                    this.$route.params.id // uuid
                )
                .then((this.tituloExportacao = ""))
                .catch((e) => {
                    console.error(
                        "Erro ao salvar exportação ",
                        this.tipoExportacao,
                        e
                    );
                    this.$root.showMessage("error", "msg-erro-exp-gerar");
                })
                .finally((_) => {
                    this.isSaving = false;
                });
        },
    },
};
</script>
<style lang="scss" scoped>
#main {
    padding: 0 20px;
    height: 100%;

    .page {
        position: relative;
        padding-left: 0;
        .nav-tabs-children {
            margin-bottom: 20px;
            li > ::after {
                bottom: -4px;
                border-width: 2px;
            }
        }

        .mobile-tab {
            cursor: pointer;

            &-list {
                width: calc(100% + 40px);
                margin-top: 20px;
                margin-bottom: 20px;
                margin-left: -20px;
                padding-right: 20px;
                padding-bottom: 5px;
                padding-left: 20px;
                border-bottom: 1px solid $table-border;
                justify-content: center;

                &::after {
                    content: "";
                    border: 3px solid $primary-color-click;
                    border-radius: 100px;
                    position: absolute;
                    width: calc(100% - 40px);
                    bottom: -3px;
                }

                &-item {
                    text-transform: uppercase;
                    font-weight: 600;
                    color: $text-color;

                    &.active {
                        color: $primary-color-click;
                    }
                }
            }

            &-text {
                text-transform: uppercase;
                font-weight: 600;
                color: $primary-color-click;

                & ~ i {
                    color: $primary-color-click;
                }
            }
        }
    }

    .exportIcons {
        display: flex;
        justify-content: flex-end;
        padding-top: 10px;
    }

    .export-icon {
        color: var(--primary-color);
        padding-right: 1rem;
    }
}

@media only screen and (max-width: 760px) {
    .nav.nav-tabs-main {
        display: flex;
        justify-content: center;
        padding: 0;
        margin: 0;

        &::after {
            display: none;
        }
    }

    .nav.nav-tabs.nav-tabs-children {
        display: none;
    }
}

@media only screen and (min-width: 761px) {
    .mobile-tab-list {
        display: none;
    }
}
.aba-visitaitem {
    height: 100%;
}
.excluir-visita {
    background-color: #f44336;

    &:hover {
        background-color: #ef8078;
    }
}
.export-opcoes {
    .modal {
        display: flex;
        justify-content: center;
    }
    .modal-content {
        width: 40% !important;
    }
    .modal-card {
        width: auto !important;
    }
    .titulo-input {
        width: 100%;
    }
    .form-buttons2 {
        top: 20px;
        display: flex;
        margin: 0 auto;

        .save-btn,
        .delete-btn {
            display: flex;
            justify-content: center;
            align-items: center;
            color: $sovis-white;
            font-size: 12px;
            height: 47px;
            padding: 15px 40px;
            border: none;
            border-radius: 6px;
            font-weight: 600;
            margin-left: 20px !important;
            @include gradient-button();
        }

        .delete-btn {
            right: 225px;
            color: $darker-gray-color;
            @include exclude-button();
        }
    }
    .ok {
        margin: 0;
    }
}

.novo-registro {
    min-width: 101px !important;
}
</style>